// extracted by mini-css-extract-plugin
export default {"form":"style_form__ptfum","wrap":"style_wrap__wgmZa","flex":"style_flex__HaTJ3","box":"style_box__RGsE0","error":"style_error__5Fr5u"};